import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyATGGIMo1fZfEcEJn2meWM53Q6S4F3HoUk",
  authDomain: "skinreport-pro.firebaseapp.com",
  projectId: "skinreport-pro",
  storageBucket: "skinreport-pro.firebasestorage.app",
  messagingSenderId: "419217829915",
  appId: "1:419217829915:web:4888ba7a369df05760c8be"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
